import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackOutboundLinkGoogleMapsEventData } from './legacy-types';
import { useLegacyTrackShownInterest } from './useLegacyTrackShownInterest';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackOutboundLinkGoogleMaps = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackOutboundLinkGoogleMapsEventData => {
  const eventData: LegacyTrackOutboundLinkGoogleMapsEventData = {
    eventType: 'microConversion',
    conversionType: 'outboundLinkGoogleMaps',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };
  return eventData;
};

export const useLegacyTrackOutboundLinkGoogleMaps = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();
  const { trackLegacyShownInterest } = useLegacyTrackShownInterest();

  const trackLegacyOutboundLinkGoogleMaps = useCallback(
    (vehicle: ElasticVehicle) => {
      trackLegacyShownInterest(vehicle);
      track({
        event: 'microConversion',
        data: createLegacyTrackOutboundLinkGoogleMaps(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyOutboundLinkGoogleMaps,
  };
};
